import { getAppLogoutReturnUrl } from "./auth-core.runtime";
import type { AuthContextValue } from "./auth-core.types";

/** Ends the Auth0 session and returns to the app's root URL. Shared by every sign-out. */
export function endAuth0Session(logout: AuthContextValue["logout"]): void {
  logout({ logoutParams: { returnTo: getAppLogoutReturnUrl() } });
}
